export default __webpack_public_path__ + "static/media/30.caec1950.png";